"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var org_root_store_1 = require("../store/org-root.store");
var employee_store_1 = require("../store/employee/employee.store");
var singleton = require("../store/employee/singleton");
var mobx_1 = require("mobx");
mobx_1.configure({ enforceActions: 'never' });
var OrgSetup = (function () {
    function OrgSetup() {
    }
    Object.defineProperty(OrgSetup, "createStore", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (masterAccountId, accessToken, baseUrl) {
            var employeeStore = new employee_store_1.EmployeeStore(masterAccountId);
            singleton.init(accessToken, baseUrl);
            var orgRootStore = new org_root_store_1.OrgRootStore(employeeStore);
            return orgRootStore;
        }
    });
    return OrgSetup;
}());
exports.OrgSetup = OrgSetup;
exports.default = OrgSetup;
